module.exports = __webpack_public_path__ + "static/img/max_pictgrid20_960x860.3daf127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid20_960x860.jpg
// module id = aH8y
// module chunks = 0